import { useState, useParams, FaSearch, FaFileExcel, FaPlusCircle, DataTable, MdArrowDownward, FaPencilAlt, FaTrash, noDatapng, ToastContainer, BiCategory, MdErrorOutline, FaArrowAltCircleRight, overlayStyle, loaderStyle } from '../../common/common';
import useNavigation from '../../common/useNavigation';
import MidViewCategories from '../../middleware/Categories/MidViewCategories';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Modal } from "react-bootstrap";
import { useErrorContext } from '../../context/ErrorContext';
import { decodeHTML } from '../../common/CommonFunctions';

const ViewCategories = () => {
    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const { error } = useErrorContext();
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, userPlan, Remainuser, subUser, isLoading, seacrh, setSearch, exporttoExcelData, filteredCategories, getCategories, handleShowModal, handleCloseModal, showAddsubcategoryModal, handleSubmit, values, handleChange, handleFileChange, fileInputRef, showEditcategoryModal, handleShowEditModal, handleCloseEditModal, deleteImage, handleEditSubmit, deleteCategory, handleGoBackToParent, setvalues, handleToggleStatus,originalImage, setOriginalImage } = MidViewCategories(type);
    const { navigateAddCategory, handlenavigateAddProducts } = useNavigation();
    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var ActiveUser = users[0]["Status"];

    }

    const columns = [
        {
            name: 'Image',
            selector: (row) => {
                const imageSrc = row.image
                    ? `${process.env.REACT_APP_API_URL}/api/uploads/category/${row.image}`
                    : `${process.env.REACT_APP_API_URL}/uploads/noproductphoto.png`;

                return (

                    <div className="w-[70px] h-[70px] overflow-hidden flex items-center justify-center">
                        <img
                            className='p-2 rounded-xl shadow'
                            width={100}
                            height={100}
                            src={imageSrc}
                            alt={row.image ? 'Category Image' : 'No Image Available'}
                        />
                    </div>
                );
            }
        },
        {
            name: "Name",
            style: {
                color: 'black',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            cell: (row) => {
                const handleClick = () => {
                    getCategories(row.id);
                    // gobackCategoryfn(row.parent_category_id);
                };

                return (
                    <button
                        className="productName"
                        onClick={handleClick}
                        style={{ background: 'none', border: 'none', color: '#196ef9', cursor: 'pointer', padding: 0, }}
                    >
                        {decodeHTML(row.name)}
                    </button>
                );
            },
        },
        {
            name: " Status ",
            sortable: true,
            cell: (row) => (
                <div className="flex items-center gap-2">

                    {ActiveUser === 1 &&
                        <label className="relative inline-flex items-center cursor-pointer">

                            <input
                                type="checkbox"
                                checked={row.status === 1}
                                onChange={() => handleToggleStatus(row.CategoryUID, !row.status)}
                                className="sr-only peer"
                            />
                            <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:bg-green-500 transition-colors duration-300"></div>
                            <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5"></div>
                        </label>
                    }
                    <span className="text-sm font-medium">
                        {row.status === 1 ? "Active" : "Inactive"}
                    </span>
                </div>
            ),
        },
        // {
        //     name: "Active",
        //     sortable: true,
        //     conditionalCellStyles: [
        //         {
        //             when: row => row.status === 1,
        //             style: { color: 'green', fontWeight: '500', },
        //         },
        //         {
        //             when: row => row.status === 0,
        //             style: { fontWeight: '500', color: 'red', },
        //         },
        //     ],
        //     selector: (row) => {
        //         const data = row.status;
        //         return (
        //             data === 1 ? 'Active '
        //                 : 'In Active '
        //         )
        //     }
        // },
        // {
        //     name: "Visible",
        //     sortable: true,
        //     conditionalCellStyles: [
        //         {
        //             when: row => row.visible === 1,
        //             style: { color: 'green', fontWeight: '500' },
        //         },
        //         {
        //             when: row => row.visible === 0,
        //             style: { fontWeight: '500', color: 'red' },
        //         },
        //     ],
        //     selector: (row) => {
        //         const data = row.visible;
        //         return data === 1 ? 'Visible' : 'Not Visible';
        //     }
        // },
        {
            name: "Action",
            selector: (row) => <div className='flex flex-col lg:flex-row space-x-2 '>
                {/* <button className='btn btn-warning  p-3 rounded-full mx-1 ' onClick={() => navigatesubgategories(row.category_unique_id)}><FaEye /></button> */}

                {ActiveUser === 1 &&
                    <Button variant="primary" className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#ebebeb] !text-black !border-[#d1d1d1]" onClick={() => { handleShowModal(row.id, row.name); }}>
                        Add sub category
                    </Button>
                }

                {ActiveUser === 1 &&
                    <Button variant="primary" className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#cbd7fa] !text-black !border-[#b9ccff] rounded-full w-10" onClick={() => handleShowEditModal(row.CategoryUID, row.id, row.name, row.image)}>
                        <FaPencilAlt className='text-[#193b99] m-auto' />
                    </Button>
                }

                {ActiveUser === 1 &&
                    <Button variant="primary" className="d-flex align-items-center btn btn-primary text-sm p-1 my-2 h-10 !bg-[#ffd7d7] !text-white !border-[#ffd7d7] rounded-full w-10 text-center " onClick={() => deleteCategory(row.id)}>
                        <FaTrash className='text-red-700 m-auto' />
                    </Button>
                }

            </div>,
        },
    ]

    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }

    return (
        <div className='md:flex md:flex-row md:w-full'>
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full  md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="lg:w-full lg:flex lg:flex-col lg:justify-between relative ">
                    <div className="w-full">
                        <div className=" p-2 mx-3 text-[#1e3a8a]">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'> Categories </h1>
                                <p className=' text-gray-600 text-[16px] '>A product category is a group of similar type of products. Ex. Menswear,Womenswear,Childrenswear</p>
                            </div>
                        </div>
                        <div className="col-start-1 col-end-13">
                            <div className=" flex-row rounded-xl m-3 p-3 bg-white shadow-xs">
                                <div className=' relative flex flex-col min-w-0 break-words'>
                                    <div className='p-2'>
                                        <div className='flex flex-col lg:flex-row justify-between items-center '>

                                            <div className='flex flex-row'>
                                                <button type="button" className="border-2 border-solid border-blue radius-md p-2 mr-2 rounded-sm bg-gray-200"
                                                    variant="outline-primary"
                                                    onClick={handleGoBackToParent} // you need to track this
                                                >
                                                    ← Back to Parent Category
                                                </button>
                                                {/* <button onClick={gobackCategory} className='mx-2'>Go Back</button> */}
                                                {/* <h5 className=" capitalize text-xl font-bold p-2">View Category</h5> */}
                                            </div>

                                            <div className='flex flex-row space-x-2'>
                                                <div className="relative bg-gray-100 rounded-md border-[1px] border-solid border-gray-200 mx-2">
                                                    <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                                                    <input
                                                        id="searchbox"
                                                        type="text"
                                                        name="searchbox"
                                                        placeholder="Search"
                                                        className="bg-transparent pl-12 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-md"
                                                        value={seacrh}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                        aria-label="Search"
                                                    />
                                                </div>

                                                <div className="hidden md:flex md:flex-row gap-2 ">

                                                    {/* {ActiveUser === 1 && */}
                                                        <Button variant="success" className="hidden md:!d-flex align-items-center !bg-[#005f0b] border-[1px] border-[#005f0b] border-solid " onClick={() => exporttoExcelData()}>
                                                            <FaFileExcel className="mr-2" />
                                                            Download Excelsheet
                                                        </Button>
                                                    {/* } */}

                                                    {ActiveUser === 1 &&
                                                        <Button variant="primary" className="md:!d-flex align-items-center hidden" onClick={navigateAddCategory}>
                                                            <FaPlusCircle className="mr-2" />
                                                            Add New Category
                                                        </Button>
                                                    }

                                                    {ActiveUser === 1 &&
                                                        <Button variant="primary" className="md:!d-flex align-items-center hidden" onClick={handlenavigateAddProducts}>
                                                            <FaPlusCircle className="mr-2" />
                                                            Add Product
                                                        </Button>
                                                    }
                                                </div>


                                                <DropdownButton
                                                    as={ButtonGroup}
                                                    title="Action"
                                                    id="bg-vertical-dropdown-3"
                                                    className="block lg:!hidden" // This will hide on smaller screens and show on larger ones
                                                >
                                                    <Dropdown.Item eventKey="1" onClick={() => exporttoExcelData()}>Download Excelsheet</Dropdown.Item>
                                                    <Dropdown.Item eventKey="2" onClick={navigateAddCategory}>Add New Category</Dropdown.Item>
                                                    <Dropdown.Item eventKey="3" onClick={handlenavigateAddProducts}>Add Product</Dropdown.Item>
                                                </DropdownButton>

                                            </div>
                                        </div>
                                        {filteredCategories && filteredCategories.length > 0 ? (
                                            <DataTable
                                                columns={columns}
                                                data={filteredCategories}
                                                pagination
                                                sortIcon={<MdArrowDownward />}
                                            />

                                        ) : (
                                            <center>
                                                <img src={noDatapng} height={300} width={300} alt="No Data Exist" />
                                                <h1 className='text-lg -translate-y-10 text-gray-300 font-bold'> No Data Exist! </h1>
                                            </center>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal size="lg" show={showAddsubcategoryModal} onHide={() => handleCloseModal} aria-labelledby="example-modal-sizes-title-lg">
                        <Modal.Body>
                            <div className="relative border-b border-slate-200/60 py-2">
                                <label className=" text-lg"> Add New Sub Category</label>
                                <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer" onClick={() => handleCloseModal()}> ESC / Close </div>
                            </div>
                            <div className='p-2'>
                                {/* onSubmit={handlesubcategorysubmit} */}
                                <form method='POST' onSubmit={handleSubmit}>
                                    <div className='row'>
                                        <div className="container m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-2">
                                            <div>
                                                <label className="block my-3">
                                                    <span className="block text-sm font-medium text-slate-700">Product Parent Category </span>
                                                </label>
                                                <div className={`${error.ParentCategory ? 'bg-red-50 border-[1px] border-solid border-red-700 mb-0' : ' bg-transparent border-border-color '} flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md `}>
                                                    <BiCategory className='text-theme-color-yellow' />
                                                    <input
                                                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 text-[#949494] cursor-not-allowed "
                                                        type="text"
                                                        name="ParentCategory"
                                                        id="ParentCategory"
                                                        value={values.ParentCategory}
                                                        readOnly
                                                    />
                                                </div>

                                            </div>

                                            <div>
                                                <label className="block my-3">
                                                    <span className="block text-sm font-medium text-slate-700">New Product Sub Category </span>
                                                </label>
                                                <div className={`${error.subCategoryName ? 'bg-red-50 border-[1px] border-solid border-red-700 mb-0' : ' bg-transparent border-border-color '} flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md `}>
                                                    <BiCategory className='text-theme-color-yellow' />
                                                    <input
                                                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                        type="text"
                                                        name="subCategoryName"
                                                        id="subCategoryName"
                                                        placeholder="Enter Product Sub Category"
                                                        autoComplete="new-password"
                                                        value={decodeHTML(values.subCategoryName)}
                                                        onChange={handleChange}
                                                    />

                                                    {error.subCategoryName &&
                                                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                    }
                                                </div>
                                                {error.subCategoryName &&
                                                    <p className='my-2 px-2 text-red-600 text-xs'>{error.subCategoryName}</p>
                                                }
                                            </div>
                                            <div>
                                                <label className="block my-3">
                                                    <span className="block text-sm font-medium text-slate-700">Product Sub Category Image</span>
                                                </label>
                                                <div className='flex flex-row '>

                                                    <label className="block">
                                                        <span className="sr-only">Choose Category photo</span>
                                                        <input type="file" className="block w-full text-sm text-slate-500
                                                                file:mr-4 file:py-2 file:px-4
                                                                file:rounded-full file:border-0
                                                                file:text-sm file:font-semibold
                                                                file:bg-violet-50 file:text-theme-color-yellow
                                                                hover:file:bg-violet-100"
                                                            name="CategoryImg"
                                                            id="CategoryImg"
                                                            ref={fileInputRef}
                                                            onChange={handleFileChange}
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <button type="submit" className="relative rounded-md group px-3 h-12 mt-5 ml-2 flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[150px]">
                                            <span className="relative text-md text-black font-semibold pl-3">Submit</span>
                                            <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl ">
                                                <FaArrowAltCircleRight className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                            </div>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <Modal size="lg" show={showEditcategoryModal} onHide={() => {
                        handleCloseEditModal();
                        setvalues({
                            editRowID: 0,
                            subCategoryName: '',
                            parentID: 0,
                            ParentCategory: '',
                            Categoryimg: '',
                            fileImage: null,
                        });
                    }}
                        aria-labelledby="example-modal-sizes-title-lg">
                        <Modal.Body>
                            <div className="relative border-b border-slate-200/60 py-2">
                                <label className=" text-lg"> Add New Sub Category</label>
                                <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer" onClick={() => {
                                    handleCloseEditModal(); setvalues({
                                        editRowID: 0,
                                        subCategoryName: '',
                                        parentID: 0,
                                        ParentCategory: '',
                                        Categoryimg: '',
                                        fileImage: null,
                                    });
                                }}> ESC / Close </div>
                            </div>
                            <div className='p-2'>
                                {/* onSubmit={handlesubcategorysubmit} */}
                                <form method='POST'>
                                    <div className='row'>
                                        <div className="container m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-2">
                                            <div>
                                                <label className="block my-3">
                                                    <span className="block text-sm font-medium text-slate-700">New Product Sub Category </span>
                                                </label>
                                                <div className={`${error.subCategoryName ? 'bg-red-50 border-[1px] border-solid border-red-700 mb-0' : ' bg-transparent border-border-color '} flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md `}>
                                                    <BiCategory className='text-theme-color-yellow' />
                                                    <input
                                                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                        type="text"
                                                        name="subCategoryName"
                                                        id="subCategoryName"
                                                        placeholder="Enter Product Sub Category"
                                                        autoComplete="new-password"
                                                        value={decodeHTML(values.subCategoryName)}
                                                        onChange={handleChange}
                                                    />
                                                    {error.subCategoryName &&
                                                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                    }
                                                </div>
                                                {error.subCategoryName &&
                                                    <p className='my-2 px-2 text-red-600 text-xs'>{error.subCategoryName}</p>
                                                }
                                            </div>
                                            <div>
                                                <label className="block my-3">
                                                    <span className="block text-sm font-medium text-slate-700">Product Sub Category Image</span>
                                                </label>
                                                <div className='flex flex-row '>
                                                    {values.Categoryimg ? (
                                                        <div className="relative">
                                                            <img
                                                                src={`${process.env.REACT_APP_API_URL}/api/Categories/uploads/${values.Categoryimg}`}
                                                                alt="Category"
                                                                width={200}
                                                                className=" h-auto" // Adjust width/height as needed
                                                            />
                                                            <button type='button'
                                                                onClick={deleteImage}
                                                                className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full"
                                                            >
                                                                &times; {/* This is the "×" symbol for the delete button */}
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <label className="block">
                                                            <span className="sr-only">Choose Category photo</span>
                                                            <input
                                                                type="file"
                                                                className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-theme-color-yellow hover:file:bg-violet-100"
                                                                name="CategoryImg"
                                                                id="CategoryImg"
                                                                ref={fileInputRef}
                                                                onChange={handleFileChange}
                                                            />
                                                        </label>
                                                    )}

                                                </div>
                                            </div>
                                        </div>

                                        <button type="button" className="relative rounded-md group px-3 h-12 mt-5 ml-2 flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[150px]" onClick={handleEditSubmit}>
                                            <span className="relative text-md text-black font-semibold pl-3">Submit</span>
                                            <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl ">
                                                <FaArrowAltCircleRight className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                            </div>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </Modal.Body>
                    </Modal>
                    <ToastContainer />
                </div>
            </div>
            {isLoading && (
                <div style={overlayStyle}>
                    <div style={loaderStyle}>Loading...</div>
                </div>
            )}
        </div >
    )
}
export default ViewCategories